<template>
  <v-container>
    <v-tab-item class="pb-0">
      <validation-observer id="tipologia-anel-estimativa" v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('secondStepAvailable', $event)" />
        <div class="display-1 font-weight-normal mb-6 text-center">Vamos começar preenchendo as informações básicas</div>
        <v-row class="mx-auto">
          <v-col class="pb-0" cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field id="nome-unitizacao" v-model="campos.nome" label="Nome" outlined :error-messages="errors" />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row align="center" class="mx-auto">
          <v-col cols="12" class="pt-1">
            <v-alert dense outlined type="info" class="mb-0 px-1 py-0">
              Módulos Aneel oficiais atualizados até:
              {{ dataUltimoIpcaOficial | formatToMonth }} ({{ mesesSemAtualizarIpcaOficial }} meses sem atualizar)
              <br />
              <template v-if="dataUltimoIpcaNaoOficial">
                Módulos Aneel estimado atualizados até:
                {{ dataUltimoIpcaNaoOficial | formatToMonth }}
              </template>
            </v-alert>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col class="pb-0 pt-1" :cols="campos.dataAplicacaoModulosAneel == 'Escolhida pelo Usuário' ? 7 : 12">
            <validation-provider id="data-aplicacao-modulos-unitizacao" v-slot="{ errors }" rules="required">
              <v-select
                v-model="campos.dataAplicacaoModulosAneel"
                no-gutters
                outlined
                label="Data aplicação dos Módulos Aneel"
                :items="[
                  'Imobilização da Obra',
                  'Início da Obra',
                  'Energização da Obra',
                  'Status Sistema da Obra',
                  'Escolhida pelo Usuário'
                ]"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col v-if="campos.dataAplicacaoModulosAneel == 'Escolhida pelo Usuário'" class="pb-0 pt-1" cols="5">
            <v-menu
              v-model="menuPickerDataUsuario"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required|min:10">
                  <v-text-field
                    v-model="campos.dataUsuarioFormatted"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    label="Data Usuário"
                    prepend-icon="mdi-calendar"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataUsuario = parseDate(campos.dataUsuarioFormatted)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataUsuario"
                locale="pt-br"
                @input="
                  menuPickerDataUsuario = false;
                  campos.dataUsuarioFormatted = formatDate(campos.dataUsuario);
                "
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col class="pb-0 pt-1" cols="12">
            <validation-provider id="unitizada-por" v-slot="{ errors }" rules="required">
              <v-select
                v-model="campos.unitizarPor"
                no-gutters
                outlined
                label="Unitizar por"
                :items="['Tucagem', 'Código do Material']"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col class="pb-0 pt-1" cols="6">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                id="qtd-min-cabo-uar"
                v-model="campos.qtdMinimaCaboUar"
                label="Qtd. mínima de cabo para ser UAR"
                type="number"
                min="0"
                outlined
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col id="col-checkbox-unitizacao-ratear" class="pb-0 pt-5" cols="6">
            <v-checkbox
              id="checkbox-unitizacao-ratear"
              v-model="campos.ratearComCaEspecifico"
              class="my-0 py-0"
              :label="labelRatearComCaEspecifico"
            />
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>
    <v-tab-item class="pb-0">
      <validation-observer id="tipologia-anel-estimativa" v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('btnFinishAvailable', $event)" />
        <div class="display-1 font-weight-normal mb-6 text-center">Selecione seus filtros para processar a unitização</div>
        <v-row v-if="isEnel" class="mx-auto">
          <v-col cols="12">
            <v-select v-model="campos.tipoBase" :items="tipoBaseList" label="Tipo de Base" />
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col cols="9">
            <v-textarea
              id="obras-unitizacao"
              v-model="campos.obras"
              class="mt-0 pt-0"
              label="Obras"
              placeholder="Insira os códigos das obras, um por linha. Ex.:

  CI1944457111 
  CI1944457348"
              rows="5"
              no-resize
              clearable
              clear-icon="mdi-close-circle"
            />
          </v-col>
          <v-col class="mt-12 pl-0" cols="3">
            <v-checkbox
              id="nao-pertence-obras-unitizacao"
              v-model="campos.obrasNaoPertencem"
              class="my-0 py-0"
              label="Não pertence"
            />
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col cols="9">
            <v-textarea
              id="tipologias-unitizacao"
              v-model="campos.tipologias"
              class="mt-0 pt-0"
              label="Tipologias"
              placeholder="Insira os códigos das tipologias, um código por linha. Ex.: 

  RAU
  RAR"
              rows="5"
              no-resize
              clearable
              clear-icon="mdi-close-circle"
            />
          </v-col>
          <v-col class="mt-12 pl-0" cols="3">
            <v-checkbox
              id="nao-pertence-tipologias-unitizacao"
              v-model="campos.tipologiasNaoPertencem"
              class="my-0 py-0"
              label="Não pertence"
            />
          </v-col>
        </v-row>
        <v-row id="data-imobilizacao-unitizacao" class="mx-auto">
          <v-col class="pb-0 pt-1" sm="5" cols="12">
            <v-menu
              v-model="menuPickerImobInicio"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    required_if: campos.dataFormattedImobFim != null && campos.dataFormattedImobFim.length > 0,
                    min: 10
                  }"
                >
                  <v-text-field
                    v-model="campos.dataFormattedImobInicio"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    label="Data Imobilização"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataImobInicio = parseDate(campos.dataFormattedImobInicio)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataImobInicio"
                locale="pt-br"
                @input="
                  menuPickerImobInicio = false;
                  campos.dataFormattedImobInicio = formatDate(campos.dataImobInicio);
                "
              />
            </v-menu>
          </v-col>
          <v-col class="py-4 text-center" style="white-space: nowrap !important" sm="1" cols="12">
            <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
          </v-col>
          <v-col class="pb-0 pt-1" sm="5" cols="12">
            <v-menu
              v-model="menuPickerImobFim"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    required_if: campos.dataFormattedImobInicio != null && campos.dataFormattedImobInicio.length > 0,
                    min: 10
                  }"
                >
                  <v-text-field
                    v-model="campos.dataFormattedImobFim"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    label="Data Imobilização"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataImobFim = parseDate(campos.dataFormattedImobFim)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataImobFim"
                locale="pt-br"
                @input="
                  menuPickerImobFim = false;
                  campos.dataFormattedImobFim = formatDate(campos.dataImobFim);
                "
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row id="data-lancamento-unitizacao" class="mx-auto">
          <v-col class="pb-0 pt-1" sm="11" cols="12">
            <v-menu
              v-model="menuPickerDataLancamento"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="min:10">
                  <v-text-field
                    v-model="campos.dataLancamentoFormatted"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    class="pt-0"
                    label="Apenas Data de Lançamento até:"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataLancamento = parseDate(campos.dataLancamentoFormatted)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataLancamento"
                locale="pt-br"
                @input="
                  menuPickerDataLancamento = false;
                  campos.dataLancamentoFormatted = formatDate(campos.dataLancamento);
                "
              />
            </v-menu>
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>
  </v-container>
</template>
<script>
  import dayjs from 'dayjs';

  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
    },

    props: {
      items: {
        type: Object,
        default: () => {}
      },
      dataUltimoIpcaOficial: {
        type: String,
        required: true
      },
      dataUltimoIpcaNaoOficial: {
        type: String,
        required: true
      },
      mesesSemAtualizarIpcaOficial: {
        type: Number,
        required: true
      }
    },

    emits: ['secondStepAvailable', 'btnFinishAvailable', 'filtroSelecionado'],

    data() {
      return {
        menuPickerImobInicio: false,
        menuPickerImobFim: false,
        menuPickerDataUsuario: false,
        menuPickerDataLancamento: false,
        isEnel: false,
        tipoBaseList: [
          { text: 'AIS', value: 'AIS' },
          { text: 'AIC', value: 'AIC' },
          { text: 'Todas', value: 'TODAS' }
        ],
        campos: {
          nome: '',
          dataAplicacaoModulosAneel: '',
          unitizarPor: '',
          qtdMinimaCaboUar: 0,
          ratearComCaEspecifico: 1,
          tipoBase: 'AIS',
          obras: '',
          obrasNaoPertencem: undefined,
          tipologias: '',
          tipologiasNaoPertencem: undefined,
          dataFormattedImobInicio: '',
          dataImobInicio: '',
          dataFormattedImobFim: '',
          dataImobFim: '',
          dataUsuario: '',
          dataUsuarioFormatted: '',
          dataLancamento: '',
          dataLancamentoFormatted: ''
        }
      };
    },

    computed: {
      minOneSelectedFilter() {
        const obras = this.campos.obras ?? '';
        const tipologias = this.campos.tipologias ?? '';

        return obras.trim() ||
          tipologias.trim() ||
          (this.campos.dataImobInicio && this.campos.dataImobFim) ||
          this.campos.dataLancamento
          ? true
          : false;
      },
      isEDP() {
        const sigla = this.$store.getters.getSiglaEmpresa.toUpperCase();
        return ['EDP', 'EDPES', 'EDP-ES', 'EDP-SP'].includes(sigla);
      },
      labelRatearComCaEspecifico() {
        return this.isEDP ? 'Ratear COM e CA Específico para Operação?' : 'Ratear COM e CA Específico para TUC?';
      }
    },

    mounted() {
      if (this.$route.params.id) {
        this.fillFields();
      }

      this.isEnel = ['EDR', 'EDG', 'EDC', 'EDS', 'EQTL-GO'].includes(this.$store.getters.getSiglaEmpresa.toUpperCase());
    },

    methods: {
      fillFields() {
        let unitizacao = this.items;
        this.campos = {
          nome: unitizacao.nome,
          dataAplicacaoModulosAneel: this.translateDataModulosAneel(unitizacao.data_aplicacao_modulos_aneel),
          unitizarPor: unitizacao.unitizar_por == 'TUCAGEM' ? 'Tucagem' : 'Código do Material',
          qtdMinimaCaboUar: unitizacao.qtd_minima_cabo_uar,
          ratearComCaEspecifico: unitizacao.ratear_com_ca_especifico,
          tipoBase: unitizacao.tipo_base,
          obras: unitizacao.obras ? this.formatTextAreaValue(unitizacao.obras) : '',
          obrasNaoPertencem: unitizacao.obras_nao_pertencem,
          tipologias: unitizacao.tipologias ? this.formatTextAreaValue(unitizacao.tipologias) : '',
          tipologiasNaoPertencem: unitizacao.tipologias_nao_pertencem,
          dataFormattedImobInicio: unitizacao.data_imobilizacao_inicial
            ? this.formatDate(unitizacao.data_imobilizacao_inicial)
            : '',
          dataImobInicio: unitizacao.data_imobilizacao_inicial
            ? this.formatDateToPicker(unitizacao.data_imobilizacao_inicial)
            : '',
          dataFormattedImobFim: unitizacao.data_imobilizacao_final ? this.formatDate(unitizacao.data_imobilizacao_final) : '',
          dataImobFim: unitizacao.data_imobilizacao_final ? this.formatDateToPicker(unitizacao.data_imobilizacao_final) : '',
          dataUsuario: unitizacao.data_usuario ? this.formatDateToPicker(unitizacao.data_usuario) : '',
          dataUsuarioFormatted: unitizacao.data_usuario ? this.formatDate(unitizacao.data_usuario) : '',
          dataLancamento: unitizacao.lancamento_ate ? this.formatDateToPicker(unitizacao.lancamento_ate) : '',
          dataLancamentoFormatted: unitizacao.lancamento_ate ? this.formatDate(unitizacao.lancamento_ate) : ''
        };
      },

      parseDate(date) {
        if (!date) return null;

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },

      formatDate(date) {
        if (date.length > 10) {
          date = date.substr(0, 10);
        }
        return dayjs(date).format('DD/MM/YYYY');
      },

      formatDateToPicker(date) {
        if (date.length > 10) {
          date = date.substr(0, 10);
        }
        return dayjs(date).format('YYYY-MM-DD');
      },

      formatTextAreaValue(valueString) {
        if (!JSON.parse(valueString).length) {
          return '';
        }

        let value = valueString.substring(2, valueString.length - 2);
        value = value.replaceAll('"', "'");
        return value.replace(/,/g, '').replace(/''/g, '\n');
      },

      translateDataModulosAneel(param) {
        switch (param) {
          case 'INICIO':
            return 'Início da Obra';
          case 'ENERGIZACAO':
            return 'Energização da Obra';
          case 'IMOBILIZACAO':
            return 'Imobilização da Obra';
          case 'STATUS_SISTEMA':
            return 'Status Sistema da Obra';
          case 'USUARIO':
            return 'Escolhida pelo Usuário';
          case 'Início da Obra':
            return 'INICIO';
          case 'Energização da Obra':
            return 'ENERGIZACAO';
          case 'Imobilização da Obra':
            return 'IMOBILIZACAO';
          case 'Status Sistema da Obra':
            return 'STATUS_SISTEMA';
          case 'Escolhida pelo Usuário':
            return 'USUARIO';
          default:
            return param;
        }
      },

      addAspasValuesTextArea(values) {
        let array = values.split('\n');
        array.forEach((val, i) => {
          if (val.trim() != '') {
            array[i] = '"' + val + '"';
          }
        });
        array = array.filter((el) => el != '');
        return '[' + array.toString() + ']';
      },

      exportData() {
        this.$emit('filtroSelecionado', this.minOneSelectedFilter);

        return {
          nome: this.campos.nome,
          data_aplicacao_modulos_aneel: this.translateDataModulosAneel(this.campos.dataAplicacaoModulosAneel),
          unitizar_por: this.campos.unitizarPor == 'Tucagem' ? 'TUCAGEM' : 'COD_MATERIAL',
          qtd_minima_cabo_uar: this.campos.qtdMinimaCaboUar ? this.campos.qtdMinimaCaboUar : 0,
          ratear_com_ca_especifico: this.campos.ratearComCaEspecifico,
          tipo_base: this.campos.tipoBase,
          obras: this.campos.obras ? this.addAspasValuesTextArea(this.campos.obras) : '[]',
          obras_nao_pertencem: this.campos.obrasNaoPertencem,
          tipologias: this.campos.tipologias ? this.addAspasValuesTextArea(this.campos.tipologias) : '[]',
          tipologias_nao_pertencem: this.campos.tipologiasNaoPertencem,
          data_imobilizacao_inicial: this.campos.dataImobInicio ? this.campos.dataImobInicio : '',
          data_imobilizacao_final: this.campos.dataImobFim ? this.campos.dataImobFim : '',
          lancamento_ate: this.campos.dataLancamento ? this.campos.dataLancamento : null,
          data_usuario: this.campos.dataUsuario ? this.campos.dataUsuario : null
        };
      }
    },

    watch: {
      items() {
        this.fillFields();
      }
    }
  };
</script>

<style>
  #col-checkbox-unitizacao-ratear label {
    font-size: 13.48px !important;
  }

  @media screen and (max-width: 739px) {
    #col-checkbox-unitizacao-ratear {
      padding-top: 12px !important;
    }
  }

  @media screen and (max-width: 494px) {
    #col-checkbox-unitizacao-ratear {
      padding-top: 4px !important;
    }
  }
</style>
